import { Box, Button, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import ModalV2 from '/@/components/bayer/modal-v2';
import { _ } from '/@/locale';

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

const ShareEmailModal = ({
    open,
    sending,
    onClose,
    onSend,
}: {
    open: boolean;
    sending: boolean;
    onClose: () => void;
    onSend: (email: string) => void;
}) => {
    const [email, setEmail] = useState('');

    // Reset the input each time the modal opens so a previous address isn't reused.
    useEffect(() => {
        if (open) {
            setEmail('');
        }
    }, [open]);

    const isValid = EMAIL_REGEX.test(email.trim());

    const handleSend = () => {
        if (isValid) {
            onSend(email.trim());
        }
    };

    return (
        <ModalV2
            open={open}
            onClose={onClose}
            title={_('Ingresá un mail')}
            maxWidth='sm'
            actions={
                <>
                    <Button variant='text' color='secondary' onClick={onClose} disabled={sending}>
                        {_('Cancelar')}
                    </Button>
                    <Button variant='contained' color='secondary' onClick={handleSend} disabled={!isValid || sending}>
                        {_('Enviar')}
                    </Button>
                </>
            }
            actionsProps={{
                justifyContent: 'flex-end',
            }}
        >
            <Box>
                <Typography variant='body1' color='primary' textAlign='center' sx={{ mb: 3 }}>
                    {_('El resultado del análisis se enviará por correo electrónico al destinatario que indiques.')}
                </Typography>
                <TextField
                    fullWidth
                    type='email'
                    value={email}
                    placeholder={_('Email')}
                    onChange={(e) => setEmail(e.target.value)}
                    onKeyDown={(e) => {
                        if (e.key === 'Enter') {
                            handleSend();
                        }
                    }}
                />
            </Box>
        </ModalV2>
    );
};

export default ShareEmailModal;
